/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import { RestResponse, Template, TemplateValue } from '../model';
import { ApiHeaders } from './headers';
import { environment } from '../../environments/environment';
import { SearchableProvider } from '../model/interface/searchable.provider';

@Injectable()
export class TemplateProvider implements SearchableProvider  {

  constructor(
    private http: HttpClient
  ) {}

  /**
   * This method will return object WITHOUT TemplateValues
   * */
  getTemplates(): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/template`, ApiHeaders.getOptions());
  }

  /**
   * This method will return full object with TemplateValues
   * */
  getTemplate(id: string): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/template/${id}`, ApiHeaders.getOptions());
  }

  /**
   * This method doesn't save included TemplateValues
   * */
  saveTemplate(template: Template): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/template`, template, ApiHeaders.getOptions());
  }

  deleteTemplate(id: string): Observable<RestResponse> {
    return this.http
      .delete<RestResponse>(`${environment.API_URL}/api/template/${id}`, ApiHeaders.getOptions());
  }

  saveTemplateValue(templateId: string, value: TemplateValue): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/template/${templateId}/value`, value, ApiHeaders.getOptions());
  }

  deleteTemplateValue(templateId: string, valueId: string): Observable<RestResponse> {
    return this.http
      .delete<RestResponse>(`${environment.API_URL}/api/template/${templateId}/value/${valueId}`, ApiHeaders.getOptions());
  }


  saveField(id: string, field: string, value: any): Observable<RestResponse> {
    return this.http
      .post<RestResponse>(`${environment.API_URL}/api/template/${id}/name`, {
        FIELD: field,
        VALUE: value
      }, ApiHeaders.getOptions());
  }

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number): Observable<RestResponse> {
    return this.getTemplates();
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return null;
  }

  getSearchType(): string {
    return 'TEMPLATE';
  }

}
